import fetch from "auth/GenericFetchInterceptor";

const PazientiService = {};

PazientiService.getListaPazienti = function (bindingRoleIds, asOf) {
    const params = new URLSearchParams();
    bindingRoleIds.forEach((id, index) => params.append(`bindingRoleIds[${index}]`, id));
    params.append('asOf', asOf);
    return fetch({
        url: `/api/audiomedical/lista-pazienti?${params}`,
        method: 'GET',
    });
};

PazientiService.getPaziente = function (id) {
    return fetch({
        url: `/api/patients/${id}`,
        method: "GET",
    });
};

PazientiService.putPaziente = function (data, id) {
    return fetch({
        url: `/api/patients/${id}`,
        method: "PUT",
        data: data
    });
};

PazientiService.addPaziente = function (data) {
    return fetch({
        url: `/api/patients`,
        method: "POST",
        data: data,
    });
};
PazientiService.deletePatient = function (id) {
    return fetch({
        url: `/api/patients/${id}`,
        method: "DELETE",
    });
};

PazientiService.getRichiamiFollowUp = function (data) {
    /*old api
    /api/patients?fields[0]=nome&fields[1]=cognome&fields[2]=anno_di_vendita&fields[3]=data_richiamo&fields[4]=descrizione_richiamo&fields[5]=operatore_richiamo&filters[data_richiamo][$lte]=${data}
    */
    return fetch({
        url: `/api/patients?fields[0]=nome&fields[1]=cognome&fields[2]=data_richiamo&fields[3]=descrizione_richiamo&fields[4]=operatore_richiamo&filters[data_richiamo][$lte]=${data}`,
        method: "GET",
    });
};

PazientiService.getPazienti = function (
    filtroOneYear,
    filtroUltima,
    filtroTipoProvenienza,
    filtroTipoPaziente,
    filtroNomeProvenienza,
    filtroStatoPaziente
) {

    console.log("filtroOneYear",filtroOneYear)

    const filtroNomeProvenienzaFinal =
        filtroNomeProvenienza == ""
            ? ""
            : filtroNomeProvenienza.reduce((acc, elemento, index, arr) => {
                return acc + elemento;
            }, "");

    const filtroStatoPazienteFinal =
        filtroStatoPaziente == ""
            ? ""
            : filtroStatoPaziente.reduce((acc, elemento, index, arr) => {
                return acc + elemento;
            }, "");
    return fetch({
        url: `/api/estrazioni?${filtroUltima}${filtroOneYear}${filtroTipoProvenienza}${filtroTipoPaziente}${filtroNomeProvenienzaFinal}${filtroStatoPazienteFinal}`,
        method: "GET",
    });
};

export default PazientiService;
